import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgShoppingCart from '../../svg/shopping-cart-5.svg'
import { IconProps } from '../icon-props'

const ShoppingCartIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgShoppingCart
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-shoppingcart', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default ShoppingCartIcon
